import React, { useEffect, useState } from 'react';
import logo from '../assets/1_Transparent_Image.png';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ConnectingAirportsIcon from '@mui/icons-material/ConnectingAirports';
import InsightsIcon from '@mui/icons-material/Insights';
import HighlightAltIcon from '@mui/icons-material/HighlightAlt';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { useSkyContext } from '../store/provider';
import { DashboardOutlined, SaveOutlined } from '@ant-design/icons';
import '../styles/Sidebar.css';

const Sidebar: React.FC = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentUrl, setCurrentUrl] = useState('');
  const skyContext = useSkyContext();

  useEffect(() => {
    setIsLoggedIn(skyContext.isAuthenticated);
  }, [skyContext.isAuthenticated]);

    useEffect(() => {
        setCurrentUrl(window.location.pathname);
    }, [isLoggedIn]);

  return isLoggedIn ? (
      <div className="sidenav">
          <img src={logo} width="150" height="150"/>
          <div className={`tab ${currentUrl === '/cockpit' ? 'active-tab' : ''}`} onClick={(a) => {
              setCurrentUrl('/cockpit')
          }}>
              <DashboardOutlined/>
              <Link to="/cockpit">Cockpit</Link>
          </div>
          <div
              className={`tab ${currentUrl === '/allmyflights' ? 'active-tab' : ''}`}
              onClick={(a) => {
                  setCurrentUrl('/allmyflights')
              }}
          >
              <ConnectingAirportsIcon/>
              <Link to="/allmyflights">All my flights</Link>
          </div>
          <div className={`tab ${currentUrl === '/insights' ? 'active-tab' : ''}`}
               onClick={(a) => {
                   setCurrentUrl('/insights')
               }}>
              <InsightsIcon/>
              <Link to="/insights">Insights</Link>
          </div>
          <div className={`tab ${currentUrl === '/selection' ? 'active-tab' : ''}`}
               onClick={(a) => {
                   setCurrentUrl('/selection')
               }}>
              <HighlightAltIcon/>
              <Link to="/selection">Selection</Link>
          </div>
          <div className={`tab ${currentUrl === '/trends' ? 'active-tab' : ''}`}
               onClick={(a) => {
                   setCurrentUrl('/trends')
               }}>
              <TrendingUpIcon/>
              <Link to="/trends">Trends</Link>
          </div>
          <div className={`tab ${currentUrl === '/saved' ? 'active-tab' : ''}`}
               onClick={(a) => {
                   setCurrentUrl('/saved')
               }}>
              <SaveOutlined/>
              <Link to="/saved">Saved reports</Link>
          </div>
      </div>
  ) : null;
};

export default Sidebar;
